import * as React from "react";
import { Badge as MantineBadge } from "@mantine/core";
import styled, { css, useTheme } from "styled-components";
import sizeForMantine from "theme/utils/sizeForMantine";
const mapStyle = (style, theme) => style === "default" ? theme.colors.button.gray.background : theme.colors.variant[style];
const mapFontSize = {
  xs: "tiny",
  sm: "small",
  md: "small",
  lg: "body"
};
const StyledBadge = styled(MantineBadge)(
  ({ theme, color, size }) => css`
    text-transform: none;
    background-color: ${color};
    color: ${theme.utils.contrastingColor(color)};

    .mantine-Badge-label {
      font-size: ${theme.fonts.size[mapFontSize[size]]};
      overflow: visible;
    }
  `
);
const Badge = ({
  bsStyle = "default",
  className = void 0,
  children = void 0,
  "data-testid": dataTestid,
  onClick = void 0,
  title = void 0,
  bsSize = "md"
}, ref) => {
  const theme = useTheme();
  const color = mapStyle(bsStyle, theme);
  const size = sizeForMantine(bsSize);
  return /* @__PURE__ */ React.createElement(
    StyledBadge,
    {
      color,
      className,
      title,
      "data-testid": dataTestid,
      ref,
      variant: "filled",
      onClick,
      size
    },
    children
  );
};
export default React.forwardRef(Badge);
